// Shim: next/navigation → react-router-dom equivalents
import { useNavigate, useLocation, useSearchParams as useRRSearchParams, useParams as useRRParams } from 'react-router-dom'
import { useMemo } from 'react'

interface NavigateOptions {
  scroll?: boolean
}

export function useRouter() {
  const navigate = useNavigate()
  return useMemo(() => ({
    push: (path: string, _opts?: NavigateOptions) => navigate(path),
    replace: (path: string, _opts?: NavigateOptions) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    prefetch: (_path: string) => { /* noop */ },
  }), [navigate])
}

export function usePathname(): string {
  const location = useLocation()
  return location.pathname
}

export function useSearchParams(): URLSearchParams {
  const [searchParams] = useRRSearchParams()
  return searchParams
}

export function useParams<T extends Record<string, string> = Record<string, string>>(): T {
  return useRRParams() as T
}

export function redirect(path: string): never {
  window.location.href = path
  throw new Error('NEXT_REDIRECT')
}

export function notFound(): never {
  throw new Error('NEXT_NOT_FOUND')
}
